export default "__VITE_ASSET__B_OC3kYE__"